
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aiselect",
      function () {
        return require("private-next-pages/aiselect/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aiselect"])
      });
    }
  